import React from "react";

const Ribbon = ({ type }) => {
  const ribbonColors = {
    vip: {
      main: "bg-[#F6B847]",
      fold: "bg-[#AC781B]",
    },
    premium: {
      main: "bg-[#EC7C65]",
      fold: "bg-[#752A1A]",
    },
    basic: {
      main: "bg-[#0B73E2]",
      fold: "bg-[#174270]",
    },
  };

  const colors = ribbonColors[type] || {
    main: "bg-gray-500",
    fold: "bg-gray-700",
  };

  return (
    <div className="relative inline-block">
      {/* Main ribbon */}
      <div
        className={`relative text-white font-bold px-6 py-[1px] translate-x-2.5 ${colors.main} font-montserrat`}
        style={{
          clipPath: "polygon(0 50%, 15% 0, 100% 0, 100% 100%, 15% 100%, 0 50%)",
          fontVariant: "small-caps",
        }}
      >
        {type}
      </div>
      {/* Tail / Fold effect on the right bottom, further reduced size */}
      <div
        className={`absolute ${colors.fold}`}
        style={{
          transform: "translateY(100%) rotate(180deg)",
          width: "10px",
          height: "10px",
          bottom: "0.1px",
          right: "-9.5px",
          clipPath: "polygon(100% 0, 0 100%, 100% 100%)",
        }}
      />
    </div>
  );
};

export default Ribbon;
